<div class="main-container">
  <div class="middle-container news-page">
    <h1 class="news-heading">News</h1>
    <div class="news-list">
      <div class="news-item" *ngFor="let item of headlines; let i = index">
        <h3 class="news-title" [innerHTML]="item.title"></h3>
        <p class="news-summary" [innerHTML]="item.summary"></p>
        <p class="news-meta" [innerHTML]="item.date"></p>
        <button class="read-more-btn" type="button" (click)="openNewsDetail(item.id)" [attr.aria-label]="'Read more about ' + item.title">
          Read more
        </button>
      </div>
    </div>
  </div>
</div>